import { useState } from "react";
// react router
import { Outlet } from "react-router";
// components
import SideDrawer from "../../components/drawer/SideDrawer";
import TopBar from "./TopBar";
// mui
import { Box } from "@mui/material";
import { topbarHeight } from "../../theme/tokens";

// hooks
import useFirebaseNotifications from "../../hooks/useFirebaseNotifications";

const MainLayout = () => {
  return <MainLayoutContent />;
};

const MainLayoutContent = () => {
  useFirebaseNotifications();
  // Single source of truth for the mobile drawer, shared by TopBar (which
  // opens it) and SideDrawer (which renders it).
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: "flex" }}>
      <TopBar onMenuClick={() => setMobileOpen(true)} />
      <SideDrawer
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: "100vh",
          paddingTop: `${topbarHeight}px`,
          backgroundColor: "background.default",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
